function RecordDownload({ record }) {
    try {

        const handleDownload = (url, fileName) => {
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            
            // setToast({
            //     show: true,
            //     message: '檔案下載中...',
            //     type: 'success'
            // });
            
            // setTimeout(() => {
            //     setToast({ show: false, message: '', type: 'success' });
            // }, 3000);
        };

        return (
            <div className="mt-4 space-y-2">
                <div 
                    className="flex justify-between items-center bg-white p-2 rounded border border-green-200"
                >
                    <div className="flex items-center">
                        <i className="fas fa-file-excel text-green-500 mr-2"></i>
                        <span className="text-sm">{record.title.replace('.pdf', '.xlsx')}</span>
                    </div>
                    <button
                        type="button"
                        onClick={() => handleDownload(record.url, record.title.replace('.pdf', '.xlsx'))}
                        className="text-sm px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors"
                    >
                        <i className="fas fa-download mr-1"></i>
                        下載
                    </button>
                </div>
            </div>
        );
    } catch (error) {
        console.error('RecordUrl component error:', error);
        reportError(error);
        return null;
    }
}

export default RecordDownload;